module.exports = __webpack_public_path__ + "img/d_2.cccd46d7.png";